var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form",
        { attrs: { inline: "" } },
        [
          _c("b-form-checkbox-group", {
            staticClass: "mb-2",
            attrs: { options: _vm.$store.state.statusList },
            model: {
              value: _vm.filter.status,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "status", $$v)
              },
              expression: "filter.status",
            },
          }),
          _vm._v(" "),
          _c("b-form-select", {
            staticClass: "mb-2",
            staticStyle: { width: "25%" },
            attrs: {
              placeholder: "Кому",
              options: _vm.usersForList,
              required: "",
            },
            model: {
              value: _vm.filter.user,
              callback: function ($$v) {
                _vm.$set(_vm.filter, "user", $$v)
              },
              expression: "filter.user",
            },
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mb-2",
              attrs: { variant: "danger" },
              on: { click: _vm.clearFilter },
            },
            [_vm._v("Сбросить фильтр")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        attrs: {
          items: _vm.items,
          fields: _vm.fields,
          filter: _vm.filter,
          "filter-function": _vm.filterFunction,
        },
        scopedSlots: _vm._u([
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c(
                  "b-button",
                  { attrs: { size: "sm" }, on: { click: row.toggleDetails } },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          row.detailsShowing ? "Скрыть" : "Изменить Удалить"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c("addOperations", {
                  attrs: { operationDefault: row.item, mode: "edit" },
                  on: {
                    "update-operations-table": function ($event) {
                      return _vm.updateOperationsTable()
                    },
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }